module.exports = __webpack_public_path__ + "static/media/picture9.9c8e95e8.png";